// extracted by mini-css-extract-plugin
var _1 = "ScaledAnswer_groupingScale__80915";
var _2 = "ScaledAnswer_icon__27f21";
var _3 = "ScaledAnswer_item__b548d";
var _4 = "ScaledAnswer_label__a19ec";
var _5 = "ScaledAnswer_mask__b9698";
export { _1 as "groupingScale", _2 as "icon", _3 as "item", _4 as "label", _5 as "mask" }
